// // app/product-brands/[slug]/TagFilterClient.tsx
// 'use client';

// import Link from 'next/link';
// import { useState } from 'react';

// interface Tag {
//     id: number;
//     name: string;
//     slug: string;
//     productCount: number;
// }

// interface TagFilterClientProps {
//     tags: Tag[];
//     brandSlug: string;
//     currentTagFilter: string;
//     totalProducts: number;
//     isMobile?: boolean;
// }

// export default function TagFilterClient({
//     tags,
//     brandSlug,
//     currentTagFilter,
//     totalProducts,
//     isMobile = false
// }: TagFilterClientProps) {
//     const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
//     const [isExpanded, setIsExpanded] = useState(false);

//     // Определим количество меток для отображения в свернутом состоянии
//     const initialTagsCount = 12;
//     const visibleTags = tags.slice(0, initialTagsCount);
//     const hasMoreTags = tags.length > initialTagsCount;

//     const toggleMobileFilter = () => {
//         setIsMobileFilterOpen(!isMobileFilterOpen);
//     };

//     const toggleExpand = () => {
//         setIsExpanded(!isExpanded);
//     };

//     const handleLinkClick = () => {
//         if (isMobileFilterOpen) {
//             setIsMobileFilterOpen(false);
//         }
//     };

//     // Мобильная версия фильтра
//     if (isMobile) {
//         return (
//             <>
//                 {/* Мобильная кнопка фильтра */}
//                 <div className="sticky top-0 z-30 bg-white mb-4">
//                     <button
//                         onClick={toggleMobileFilter}
//                         className="bg-[#fff] hover:bg-[#fff] w-fit p-2 gap-[5px] text-[#4b5563] rounded-md flex items-center justify-center border border-gray-200"
//                     >
//                         <svg className='w-[20px]' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M21 6H19M21 12H16M21 18H16M7 20V13.5612C7 13.3532 7 13.2492 6.97958 13.1497C6.96147 13.0615 6.93151 12.9761 6.89052 12.8958C6.84431 12.8054 6.77934 12.7242 6.64939 12.5617L3.35061 8.43826C3.22066 8.27583 3.15569 8.19461 3.10948 8.10417C3.06849 8.02393 3.03853 7.93852 3.02042 7.85026C3 7.75078 3 7.64677 3 7.43875V5.6C3 5.03995 3 4.75992 3.10899 4.54601C3.20487 4.35785 3.35785 4.20487 3.54601 4.10899C3.75992 4 4.03995 4 4.6 4H13.4C13.9601 4 14.2401 4 14.454 4.10899C14.6422 4.20487 14.7951 4.35785 14.891 4.54601C15 4.75992 15 5.03995 15 5.6V7.43875C15 7.64677 15 7.75078 14.9796 7.85026C14.9615 7.93852 14.9315 8.02393 14.8905 8.10417C14.8443 8.19461 14.7793 8.27583 14.6494 8.43826L11.3506 12.5617C11.2207 12.7242 11.1557 12.8054 11.1095 12.8958C11.0685 12.9761 11.0385 13.0615 11.0204 13.1497C11 13.2492 11 13.3532 11 13.5612V17L7 20Z"
//                                 stroke="#383c42" strokeWidth="0.936" strokeLinecap="round" strokeLinejoin="round" />
//                         </svg>
//                         Фильтр по меткам
//                     </button>
//                 </div>

//                 {/* Мобильный фильтр - боковая панель */}
//                 <div className={`fixed inset-y-0 left-0 z-[100000001] w-[340px] bg-white shadow-lg transform ${isMobileFilterOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out`}>
//                     <div className="h-full flex flex-col">
//                         <div style={{ borderBottom: '1px solid #d3d3d3' }} className="p-4 flex justify-between items-center">
//                             <h3 className="font-medium">Метки товаров</h3>
//                             <button
//                                 onClick={toggleMobileFilter}
//                                 className="bg-[#fff] hover:bg-[#fff] w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700"
//                             >
//                                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                                 </svg>
//                             </button>
//                         </div>

//                         <div className="flex-1 overflow-y-auto p-4">
//                             <div className="space-y-2">
//                                 {/* Кнопка "Все метки" */}
//                                 <Link
//                                     href={`/product-brands/${brandSlug}?page=1`}
//                                     onClick={handleLinkClick}
//                                     className={`block w-full text-left px-3 py-2 rounded-lg border transition-colors ${!currentTagFilter
//                                             ? 'border-[#ff7900] bg-orange-50 text-[#ff7900]'
//                                             : 'border-gray-200 hover:border-gray-300'
//                                         }`}
//                                 >
//                                     <div className="flex justify-between items-center">
//                                         <span className="font-medium">Все метки</span>
//                                         <span className="text-sm text-gray-500">({totalProducts})</span>
//                                     </div>
//                                 </Link>

//                                 {/* Список меток */}
//                                 {tags.map((tag) => (
//                                     <Link
//                                         key={tag.id}
//                                         href={`/product-brands/${brandSlug}?tag=${tag.slug}&page=1`}
//                                         onClick={handleLinkClick}
//                                         className={`block w-full text-left px-3 py-2 rounded-lg border transition-colors ${currentTagFilter === tag.slug
//                                                 ? 'border-[#ff7900] bg-orange-50 text-[#ff7900]'
//                                                 : 'border-gray-200 hover:border-gray-300'
//                                             }`}
//                                     >
//                                         <div className="flex justify-between items-center">
//                                             <span>{tag.name}</span>
//                                             <span className="text-sm text-gray-500">({tag.productCount})</span>
//                                         </div>
//                                     </Link>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Затемнение фона при открытом мобильном фильтре */}
//                 {isMobileFilterOpen && (
//                     <div
//                         className="fixed inset-0 bg-black bg-opacity-50 z-[100000000]"
//                         onClick={toggleMobileFilter}
//                     ></div>
//                 )}
//             </>
//         );
//     }

//     // Десктопная версия фильтра
//     return (
//         <div className="bg-white rounded-lg border border-gray-200 p-4">
//             <h3 className="font-medium text-lg mb-4">Фильтр по меткам</h3>

//             <div className="space-y-2">
//                 {/* Кнопка "Все метки" */}
//                 <Link
//                     href={`/product-brands/${brandSlug}?page=1`}
//                     className={`block w-full text-left px-3 py-2 rounded-lg border transition-colors ${!currentTagFilter
//                             ? 'border-[#ff7900] bg-orange-50 text-[#ff7900]'
//                             : 'border-gray-200 hover:border-gray-300'
//                         }`}
//                 >
//                     <div className="flex justify-between items-center">
//                         <span className="font-medium">Все метки</span>
//                         <span className="text-sm text-gray-500">({totalProducts})</span>
//                     </div>
//                 </Link>

//                 {/* Список видимых меток */}
//                 {visibleTags.map((tag) => (
//                     <Link
//                         key={tag.id}
//                         href={`/product-brands/${brandSlug}?tag=${tag.slug}&page=1`}
//                         className={`block w-full text-left px-3 py-2 rounded-lg border transition-colors ${currentTagFilter === tag.slug
//                                 ? 'border-[#ff7900] bg-orange-50 text-[#ff7900]'
//                                 : 'border-gray-200 hover:border-gray-300'
//                             }`}
//                     >
//                         <div className="flex justify-between items-center">
//                             <span>{tag.name}</span>
//                             <span className="text-sm text-gray-500">({tag.productCount})</span>
//                         </div>
//                     </Link>
//                 ))}

//                 {/* Разворачиваемый раздел с дополнительными метками */}
//                 {hasMoreTags && (
//                     <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
//                         }`}>
//                         {isExpanded && (
//                             <div className="space-y-2 pt-2">
//                                 {tags.slice(initialTagsCount).map((tag, index) => (
//                                     <Link
//                                         key={tag.id}
//                                         href={`/product-brands/${brandSlug}?tag=${tag.slug}&page=1`}
//                                         className={`block w-full text-left px-3 py-2 rounded-lg border transition-colors ${currentTagFilter === tag.slug
//                                                 ? 'border-[#ff7900] bg-orange-50 text-[#ff7900]'
//                                                 : 'border-gray-200 hover:border-gray-300'
//                                             }`}
//                                         style={{
//                                             animationDelay: `${index * 30}ms`,
//                                             opacity: 0,
//                                             animation: `fadeIn 300ms ease-in-out ${index * 30}ms forwards`
//                                         }}
//                                     >
//                                         <div className="flex justify-between items-center">
//                                             <span>{tag.name}</span>
//                                             <span className="text-sm text-gray-500">({tag.productCount})</span>
//                                         </div>
//                                     </Link>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 )}

//                 {/* Кнопка "Показать больше" */}
//                 {hasMoreTags && (
//                     <div className="pt-2">
//                         <button
//                             onClick={toggleExpand}
//                             className="text-[#ff7900] bg-[#fff] hover:bg-[#fff] hover:underline flex items-center justify-center w-full py-2"
//                         >
//                             <span className="mr-1">{isExpanded ? 'Свернуть' : 'Показать все метки'}</span>
//                             <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 className={`transition-transform duration-300 ${isExpanded ? 'rotate-180' : 'rotate-0'}`}
//                             >
//                                 <polyline points="6 9 12 15 18 9"></polyline>
//                             </svg>
//                         </button>
//                     </div>
//                 )}
//             </div>

//             <style jsx global>{`
//                 @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//             `}</style>
//         </div>
//     );
// }


// app/product-brands/[slug]/TagFilterClient.tsx
'use client';

import Link from 'next/link';
import { useState } from 'react';

interface Tag {
    id: number;
    name: string;
    slug: string;
    productCount: number;
}

interface TagFilterClientProps {
    tags: Tag[];
    brandSlug: string;
    currentTagFilter: string;
    totalProducts: number;
    isMobile?: boolean;
}

export default function TagFilterClient({
    tags,
    brandSlug,
    currentTagFilter,
    totalProducts,
    isMobile = false
}: TagFilterClientProps) {
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    const initialTagsCount = 8;
    const visibleTags = tags.slice(0, initialTagsCount);
    const hasMoreTags = tags.length > initialTagsCount;

    const toggleMobileFilter = () => {
        setIsMobileFilterOpen(!isMobileFilterOpen);
    };

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    // const handleLinkClick = () => {
    //     if (isMobileFilterOpen) {
    //         setIsMobileFilterOpen(false);
    //     }
    // };
    const handleLinkClick = () => {
        if (isMobileFilterOpen) {
            setIsMobileFilterOpen(false);
        }
        // Добавляем скролл для мобильных устройств
        if (isMobile) {
            setTimeout(() => {
                const element = document.getElementById('acnhor-page-point');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    };



    // Мобильная версия
    if (isMobile) {
        return (
            <>
                {/* Компактная кнопка фильтра */}
                {/* <div className="sticky top-0 z-30 bg-white/95 backdrop-blur-sm mb-3 py-2">
                    <button
                        onClick={toggleMobileFilter}
                        className="bg-white hover:bg-gray-50 px-3 py-2 rounded-full shadow-sm border border-gray-200 flex items-center gap-2 text-sm font-medium text-gray-700 transition-all duration-200"
                    >
                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 7H21M6 12H18M9 17H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        Фильтр
                        <span className="bg-gray-100 px-2 py-0.5 rounded-full text-xs">
                            {currentTagFilter ? tags.find(t => t.slug === currentTagFilter)?.productCount || 0 : totalProducts}
                        </span>
                    </button>
                </div> */}

                <div className="sticky top-0 z-30 bg-white">
                    <button
                        onClick={toggleMobileFilter}
                        className="bg-[#fff] hover:bg-[#fff] w-fit p-0 gap-[5px] text-[#4b5563] rounded-md flex items-center justify-center"
                    >
                        <svg className='w-[20px]' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path d="M21 6H19M21 12H16M21 18H16M7 20V13.5612C7 13.3532 7 13.2492 6.97958 13.1497C6.96147 13.0615 6.93151 12.9761 6.89052 12.8958C6.84431 12.8054 6.77934 12.7242 6.64939 12.5617L3.35061 8.43826C3.22066 8.27583 3.15569 8.19461 3.10948 8.10417C3.06849 8.02393 3.03853 7.93852 3.02042 7.85026C3 7.75078 3 7.64677 3 7.43875V5.6C3 5.03995 3 4.75992 3.10899 4.54601C3.20487 4.35785 3.35785 4.20487 3.54601 4.10899C3.75992 4 4.03995 4 4.6 4H13.4C13.9601 4 14.2401 4 14.454 4.10899C14.6422 4.20487 14.7951 4.35785 14.891 4.54601C15 4.75992 15 5.03995 15 5.6V7.43875C15 7.64677 15 7.75078 14.9796 7.85026C14.9615 7.93852 14.9315 8.02393 14.8905 8.10417C14.8443 8.19461 14.7793 8.27583 14.6494 8.43826L11.3506 12.5617C11.2207 12.7242 11.1557 12.8054 11.1095 12.8958C11.0685 12.9761 11.0385 13.0615 11.0204 13.1497C11 13.2492 11 13.3532 11 13.5612V17L7 20Z" stroke="#383c42" strokeWidth="0.9359999999999999" strokeLinecap="round" strokeLinejoin="round"></path>
                            </g>
                        </svg>
                        Фильтры
                    </button>
                </div>

                {/* Мобильная панель фильтра */}
                <div className={`fixed inset-0 z-[99999] transform transition-all duration-300 ${isMobileFilterOpen ? 'translate-y-0' : 'translate-y-full'}`}>
                    <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" onClick={toggleMobileFilter}></div>

                    <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl max-h-[80vh] flex flex-col ">
                        {/* Хедер с drag индикатором */}
                        <div className="flex-shrink-0 p-4 border-b border-gray-100">
                            <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-3"></div>
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="font-semibold text-gray-900">Метки товаров</h3>
                                    <p className="text-sm text-gray-500">{tags.length} доступно</p>
                                </div>
                                <button
                                    onClick={toggleMobileFilter}
                                    className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-gray-200 transition-colors"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        {/* Контент */}
                        <div className="flex-1 overflow-y-auto p-4">
                            <div className="space-y-2">
                                {/* Все метки */}
                                <Link
                                    href={`/product-brands/${brandSlug}?page=1`}
                                    onClick={handleLinkClick}
                                    className={`flex items-center gap-[10px] justify-between p-3 rounded-xl transition-all ${!currentTagFilter
                                        ? 'bg-orange-50 border-2 border-orange-200 text-orange-700'
                                        : 'bg-gray-50 border-2 border-transparent hover:border-gray-200'
                                        }`}
                                >
                                    <span className="font-medium">Все товары</span>
                                    <span className="bg-white px-2 py-1 rounded-lg text-sm font-medium">
                                        {totalProducts}
                                    </span>
                                </Link>

                                {/* Список меток */}
                                {tags.map((tag) => (
                                    <Link
                                        key={tag.id}
                                        href={`/product-brands/${brandSlug}?tag=${tag.slug}&page=1`}
                                        onClick={handleLinkClick}
                                        className={`flex items-center gap-[10px] justify-between p-3 rounded-xl transition-all ${currentTagFilter === tag.slug
                                            ? 'bg-orange-50 border-2 border-orange-200 text-orange-700'
                                            : 'bg-gray-50 border-2 border-transparent hover:border-gray-200'
                                            }`}
                                    >
                                        <span className="font-medium">{tag.name}</span>
                                        <span className="bg-white px-2 py-1 rounded-lg text-sm font-medium">
                                            {tag.productCount}
                                        </span>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // Десктопная версия - компактная карточка
    return (
        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
            <div className="p-4 border-b border-gray-100">
                <h3 className="font-semibold text-gray-900">Фильтр по меткам</h3>
                <p className="text-sm text-gray-500 mt-1">{tags.length} доступно</p>
            </div>

            <div className="p-4">
                <div className="space-y-2">
                    {/* Все метки */}
                    <Link
                        href={`/product-brands/${brandSlug}?page=1`}
                        className={`flex items-center justify-between gap-[10px] p-3 rounded-xl transition-all ${!currentTagFilter
                            ? 'bg-orange-50 border-2 border-orange-200 text-orange-700'
                            : 'bg-gray-50 border-2 border-transparent hover:border-gray-200'
                            }`}
                    >
                        <span className="font-medium">Все метки</span>
                        <span className="bg-white px-2 py-1 rounded-lg text-sm font-medium">
                            {totalProducts}
                        </span>
                    </Link>

                    {/* Видимые метки */}
                    {visibleTags.map((tag) => (
                        <Link
                            key={tag.id}
                            href={`/product-brands/${brandSlug}?tag=${tag.slug}&page=1`}
                            className={`flex items-center justify-between gap-[10px] p-3 rounded-xl transition-all ${currentTagFilter === tag.slug
                                ? 'bg-orange-50 border-2 border-orange-200 text-orange-700'
                                : 'bg-gray-50 border-2 border-transparent hover:border-gray-200'
                                }`}
                        >
                            <span className="font-medium">{tag.name}</span>
                            <span className="bg-white px-2 py-1 rounded-lg text-sm font-medium">
                                {tag.productCount}
                            </span>
                        </Link>
                    ))}

                    {/* Скрытые метки */}
                    {hasMoreTags && (
                        <div className={`space-y-2 overflow-hidden transition-all duration-500 ${isExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                            }`}>
                            {isExpanded && tags.slice(initialTagsCount).map((tag, index) => (
                                <Link
                                    key={tag.id}
                                    href={`/product-brands/${brandSlug}?tag=${tag.slug}&page=1`}
                                    className={`flex items-center justify-between gap-[10px] p-3 rounded-xl transition-all ${currentTagFilter === tag.slug
                                        ? 'bg-orange-50 border-2 border-orange-200 text-orange-700'
                                        : 'bg-gray-50 border-2 border-transparent hover:border-gray-200'
                                        }`}
                                    style={{
                                        animationDelay: `${index * 50}ms`,
                                        opacity: 0,
                                        animation: `slideIn 400ms ease-out ${index * 50}ms forwards`
                                    }}
                                >
                                    <span className="font-medium">{tag.name}</span>
                                    <span className="bg-white px-2 py-1 rounded-lg text-sm font-medium">
                                        {tag.productCount}
                                    </span>
                                </Link>
                            ))}
                        </div>
                    )}

                    {/* Кнопка показать больше */}
                    {hasMoreTags && (
                        <button
                            onClick={toggleExpand}
                            className="w-full mt-3 p-3 text-orange-600 bg-orange-50 hover:bg-orange-100 rounded-xl flex items-center justify-center gap-2 transition-all font-medium"
                        >
                            <span>{isExpanded ? 'Свернуть' : `Показать ещё ${tags.length - initialTagsCount}`}</span>
                            <svg
                                className={`w-4 h-4 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                    )}
                </div>
            </div>

            <style jsx global>{`
                @keyframes slideIn {
                    from { 
                        opacity: 0; 
                        transform: translateY(-10px); 
                    }
                    to { 
                        opacity: 1; 
                        transform: translateY(0); 
                    }
                }
            `}</style>
        </div>
    );
}